import type { SkeletonProps } from '@mui/material';

export const DEFAULT_EXPANDED_PARENTS = ['Integration', 'API Integration'];

const SKELETON_ROW_COUNT = 6;

export const SKELETON_CONFIG: SkeletonProps[] = Array.from(
  { length: SKELETON_ROW_COUNT },
  () => ({ variant: 'rounded', height: 56 })
);

export const rows = [
  {
    title: 'AI Lookalike Company Finder',
    free: true,
    standard: true,
    hasChevron: false,
  },
  {
    title: 'AI Lookalike People Finder',
    free: true,
    standard: true,
    hasChevron: false,
  },
  { title: 'AI Buying Team', free: true, standard: true, hasChevron: false },
  {
    title: 'B2B Basic Filters',
    free: true,
    standard: true,
    hasChevron: true,
    details: [
      {
        title: 'Record Management',
        items: [
          { name: 'In & Exclude Lists', free: true, standard: true },
          { name: 'In & Exclude Labels', free: true, standard: true },
          { name: 'In & Exclude Record Ownership', free: true, standard: true },
        ],
      },
      {
        title: 'Company Search Filters:',
        items: [
          { name: 'Location', free: true, standard: true },
          { name: 'Job Role ', free: true, standard: true },
          { name: 'People Info ', free: true, standard: true },
          { name: 'Social Media Channels ', free: true, standard: true },
        ],
      },
      {
        title: 'People Search Filters:',
        items: [
          { name: 'Company Info', free: true, standard: true },
          { name: 'Company Search', free: true, standard: true },
          { name: 'Industry', free: true, standard: true },
          { name: 'Location', free: true, standard: true },
          { name: 'Employee Size', free: true, standard: true },
          { name: 'Technologies', free: true, standard: true },
          { name: 'Social Media Channels', free: true, standard: true },
          { name: 'Founded Year', free: true, standard: true },
          { name: 'Lookalike Relevancy', free: true, standard: true },
          { name: 'Operation Language', free: true, standard: true },
          {
            name: 'Number of Locations: World Wide',
            free: true,
            standard: true,
          },
        ],
      },
    ],
  },
  {
    title: 'B2B Advanced Filters',
    free: false,
    standard: true,
    hasChevron: true,
    details: [
      {
        title: 'Company Search Filters',
        items: [
          { name: 'Keywords', free: false, standard: true },
          { name: 'Annual Revenue', free: false, standard: true },
          { name: 'Product & Services', free: false, standard: true },
          { name: 'Funding', free: false, standard: true },
          { name: 'Employee By Department', free: false, standard: true },
          { name: 'Headcount Growth', free: false, standard: true },
          { name: 'Company Type', free: false, standard: true },
          { name: 'Signals & Alerts', free: false, standard: true },
        ],
      },
      {
        title: 'People Search Filters',
        items: [
          { name: 'Keywords', free: true, standard: true },
          { name: 'Annual Revenue', free: true, standard: true },
        ],
      },
    ],
  },
  {
    title: 'AI Contact Analysis',
    free: true,
    standard: true,
    hasChevron: true,
    details: [
      {
        items: [
          { name: 'AI Personality Sales Analysis', free: true, standard: true },
          {
            name: 'AI Personality Talent Analysis',
            free: true,
            standard: true,
            comingSoon: true,
          },
          {
            name: 'AI Buying Team Analysis',
            free: true,
            standard: true,
            comingSoon: true,
          },
          {
            name: 'AI Product Team Analysis',
            free: true,
            standard: true,
            comingSoon: true,
          },
        ],
      },
    ],
  },
  {
    title: 'CSV Enrichment',
    free: true,
    standard: true,
    hasChevron: true,
    details: [
      {
        items: [
          { name: 'Company Detail Enrichment', free: true, standard: true },
          {
            name: 'Contact Detail Enrichment',
            free: true,
            standard: true,
          },
          { name: 'Find Email Enrichment', free: true, standard: true },
          { name: 'Email Verifier', free: true, standard: true },
        ],
      },
    ],
  },
  {
    title: 'CSV Export Types',
    free: true,
    standard: true,
    hasChevron: true,
    details: [
      {
        items: [
          { name: 'All Data Export', free: true, standard: true },
          { name: 'LinkedIn Audience Export', free: true, standard: true },
          { name: 'Sales Navigator Export', free: true, standard: true },
        ],
      },
    ],
  },
  {
    title: 'Integration',
    free: false,
    standard: true,
    hasChevron: true,
    details: [
      {
        items: [
          { name: 'Zapier', free: false, standard: true, comingSoon: true },
          { name: 'Outreach', free: false, standard: true, comingSoon: true },
          { name: 'SalesLoft', free: false, standard: true, comingSoon: true },
          { name: 'Smartleads', free: false, standard: true, comingSoon: true },
          { name: 'Clay', free: false, standard: true, comingSoon: true },
        ],
      },
    ],
  },
  {
    title: 'API Access',
    free: false,
    standard: true,
    hasChevron: true,
    details: [
      {
        items: [
          {
            name: 'Call Limit Per Minute',
            free: '-',
            standard: '200',
            useNumbers: true,
          },
          {
            name: 'Call Limit Per Hour',
            free: '-',
            standard: '400',
            useNumbers: true,
          },
          {
            name: 'Call Limit Per Day',
            free: '-',
            standard: '2,000',
            useNumbers: true,
          },
        ],
      },
    ],
  },
];
